module.exports = __webpack_public_path__ + "bin/fc8bc96a8ce0b2ccc98e70acc8ce0d11.ttf";